module.exports = __webpack_public_path__ + "img/not-authorized-dark.38307758.svg";